import { render, staticRenderFns } from "./ErrorPanel.vue?vue&type=template&id=0d117ca1&scoped=true&"
import script from "./ErrorPanel.vue?vue&type=script&lang=ts&"
export * from "./ErrorPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorPanel.vue?vue&type=style&index=0&id=0d117ca1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d117ca1",
  null
  
)

export default component.exports